import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarUsuariosService } from "../services/buscarUsuariosService";

// --------------------- Import Interfaces ---------------------
import { Usuario } from "../Interfaces/Usuario";

export const useBuscarUsuarios = () => {
  const [usuarios, setUsuarios] = useState<Usuario[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUsuarios = async () => {
      const data = await buscarUsuariosService();
      setUsuarios(data);
      setIsLoading(false);
    };

    fetchUsuarios();
  }, []);

  return { usuarios, isLoading };
};
